// Horloge du serveur : chaque réponse du service porte serverTime ; les appareils décomptent jusqu'à l'heure de fin
// du coup avec leur propre horloge corrigée de cet écart (le chrono finit au même moment partout).
// L'écart est mesuré au milieu de l'aller-retour, et l'on garde l'échantillon au plus court aller-retour (le plus
// précis) tant qu'il a moins d'une minute : le chrono ne saute pas d'une réponse à l'autre.
const MAX_AGE = 60000;
let best;

export function sample({ serverTime, sentAt, receivedAt }) {
  if (!Number.isFinite(serverTime) || !Number.isFinite(sentAt) || !Number.isFinite(receivedAt)) {
    return;
  }
  const roundTrip = receivedAt - sentAt;
  const candidate = { offset: serverTime - ((sentAt + receivedAt) / 2), roundTrip, at: receivedAt };
  if (!best || roundTrip <= best.roundTrip || receivedAt - best.at > MAX_AGE) {
    best = candidate;
  }
}

export function reset() {
  best = undefined;
}

export function offsetOf() {
  return best ? best.offset : 0;
}

export function now() {
  return Date.now() + offsetOf();
}
